import React from "react"

export default () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" className="fill-current">
    <title>Linked-in</title>
    <path d="M27.264 27.27h-4.74v-7.426c0-1.772-0.036-4.050-2.468-4.050-2.47 0-2.848 1.928-2.848 3.92v7.556h-4.74v-15.27h4.552v2.080h0.060c0.636-1.2 2.184-2.466 4.494-2.466 4.8 0 5.69 3.16 5.69 7.274v8.376zM7.116 9.91c-1.524 0-2.752-1.234-2.752-2.754 0-1.516 1.228-2.75 2.752-2.75 1.52 0 2.752 1.234 2.752 2.75 0 1.52-1.234 2.754-2.752 2.754zM9.492 27.27h-4.752v-15.27h4.752v15.27zM29.632 0h-27.272c-1.304 0-2.36 1.032-2.36 2.306v27.388c0 1.274 1.056 2.306 2.36 2.306h27.27c1.304 0 2.37-1.032 2.37-2.306v-27.388c0-1.274-1.066-2.306-2.37-2.306z"></path>
  </svg>
)
